import React, { Component } from 'react';
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Paper,
  ListItemIcon,
  ClickAwayListener,
  IconButton,
} from '@quillbot/design-system';
import withStyles from '@mui/styles/withStyles';
import {
  CommentOutlined as CommentOutlinedIcon,
  MoreVertOutlined as MoreVertOutlinedIcon,
} from '@mui/icons-material';
import { APP_SETTINGS } from 'config/constants';
import { openDrawer } from '@Common/handlers/services';
import FeedbackDrawer from 'src/_common/components/drawer/FeedbackDrawer';
import ShowInMobile from 'src/_common/quillElements/fragment/ShowInMobile';
import HideInMobile from 'src/_common/quillElements/fragment/HideinMobile';

const styles = (theme) => ({
  iconButton: {
    // padding: '6px',
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
  paper: {
    padding: 0,
    overflow: 'hidden',
    zIndex: 2,
    position: 'absolute',
    left: 0,
    right: 0,
    borderRadius: '0px',
    border: `1px solid ${theme.palette.divider}`,
  },

  feedbackIconMobile: {},
});

class ControlBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showKebabOptions: false,
    };
    this.anchorRef = React.createRef();
  }

  handleListKeyDown = (event) => {
    if (event.key === 'Tab') {
      event.preventDefault();
    }
  };

  toggleKebabOptions = (e) => {
    this.setState((state) => ({
      showKebabOptions: !state.showKebabOptions,
    }));
    e.stopPropagation();
  };

  closeKebabOptions = () => {
    this.setState({ showKebabOptions: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <ShowInMobile>
          <ClickAwayListener onClickAway={this.closeKebabOptions}>
            <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
              <div>
                <IconButton
                  disableRipple
                  onClick={this.toggleKebabOptions}
                  className={`KebabBtn ${classes.iconButton}`}
                  size="large">
                  <MoreVertOutlinedIcon />
                </IconButton>
              </div>
              {this.state.showKebabOptions && (
                <Paper className={classes.paper}>
                  <List component="nav" style={{ padding: '0px 0px' }}>
                    <ListItem
                      button
                      onClick={(e) => {
                        e.stopPropagation();
                        openDrawer('FEEDBACK', FeedbackDrawer);
                      }}>
                      <ListItemIcon>
                        <CommentOutlinedIcon className={classes.feedbackIconMobile} />
                      </ListItemIcon>
                      <ListItemText primary="Feedback" />
                    </ListItem>
                  </List>
                </Paper>
              )}
            </Grid>
          </ClickAwayListener>
        </ShowInMobile>
        <HideInMobile>
          <Grid container direction="row" alignItems="center" justifyContent="flex-end">
            <Grid item style={{ paddingRight: '6px' }}>
              <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                <Grid item xs={12} md={4} xl={4} lg={4} sm={12}>
                  <Tooltip arrow title={APP_SETTINGS.showToolTips ? <>Give Feedback</> : <></>}>
                    <IconButton
                      onClick={() => openDrawer('FEEDBACK', FeedbackDrawer)}
                      classes={{ root: classes.iconButton }}
                      size="large">
                      <CommentOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </HideInMobile>
      </>
    );
  }
}

export default withStyles(styles)(ControlBar);
